import React from 'react';

const Contact = () => (
	<div class='mt-5'>
		<section className='container'>
			<h1>This is the Contact Page</h1>
		</section>
	</div>
);

export default Contact;
